/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Cc_Mode_EnabledInputs */



/**
* | output |
* | --- |
* | "Closed Caption Mode Enabled" |
*
* @param {Styles_Cc_Mode_EnabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_cc_mode_enabled = /** @type {((inputs?: Styles_Cc_Mode_EnabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Cc_Mode_EnabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode sous-titrage active")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelmodus aktiviert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità sottotitoli abilitata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Режим субтитров включен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de subtítulos habilitado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已启用隐藏式字幕模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローズドキャプションモードが有効")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज्ड कैप्शन मोड सक्षम किया गया है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas ativadas")
	return /** @type {LocalizedString} */ ("Closed Caption Mode Enabled")
});